import React, { FC } from "react";
import EChartsReact from "echarts-for-react";
import {
  Paper
} from "@material-ui/core";
import { trafficLight } from "../../theme";
import { Label } from "@material-ui/icons";
import { dataEntry, IDataTest } from "../../types/types";


interface IFMChartProps {
  data: IDataTest<dataEntry>
}

const PieChart: FC<IFMChartProps> = ({ data }) => {

  const data_series = data.data.map((entry, index) => {

    if (entry.value[0] === 0 && (entry.name === 'Undefined' || entry.name === 'Cannot Determine')) {
      return
    } else {

      return {

        value: entry.value,
        name: entry.name,
        itemStyle: {
          color: data.colour.background[index],
        },
        label: {
          color: data.colour.font[index],
          fontWeight: 'bold',

        }
      }
    }
  })

  // set height if height is set in data
  const height = data.height ? data.height : "250px";

  const subtitle = data.subtitle ? data.subtitle : "";

  const radius = data.radius ? data.radius : "60%";

  // set a custom tooltip for the legend for the Sok Chart
  const set_toolTip = (title: string, parameters: any) => {


    if (title === 'Portfolio Summary') {

      if (parameters === 'Adequate') {
        return "Adequate level of detail <br> for Formal SFAIRP assessment"
      }
      else if (parameters === 'Questionable') {
        return "SFAIRP outcome is Preliminary unless additional <br> investigations are carried out to address the data gaps"
      }
      else if (parameters === 'Inadequate') {
        return "Inadequate for SFAIRP Assessment. <br> SFAIRP outcome is Preliminary or Indeterminate"
      }

    }

  }



  const getOption = () => {

    return {
      title: {
        text: data.title,
        subtext: subtitle,
        left: 'center',
        textStyle: {
          color: 'black'
          }
      },
      tooltip: {
        trigger: 'item'
      },
      toolbox: {
        show: true,
        top: 0,
        feature: {
          saveAsImage: {
            show: true,
            pixelRatio: 20
          },
          dataView: {
            show: true,
            readOnly: false

          }
        },
      },
      legend: {
        bottom: 'bottom',
        tooltip: {
          show: true,
          formatter: function (params: any) {
            return set_toolTip(data.title, params.name)

          }
        },
        formatter: function (name: string): string {

          if (data.legend_labels) {
            let itemValue = data.data.findIndex(item => item.name === name)
            return data.legend_labels[itemValue]
          }
          return name
        }

      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: radius,
          labelLine: { show: false },
          data: data_series,
          label: {
            formatter: function (param: any) {
              
                return param.data.value[0] === 0 ? '' : `${param.name}: ${param.value}`; 
            }
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]

    };
  }

  return (<>
    <div style={{ padding: "10px" }}>
      <Paper variant={"outlined"}>
        <EChartsReact option={getOption()} style={{ height: height }} />
      </Paper>
    </div>

  </>
  );

}

export default PieChart;
